import React, { Component } from "react";
import WhatappPNG from "../../../../Assets/png/whatsapp.png";

class WhatsAppNewChat extends Component {
  render() {
    return (
      <div className="flex flex-col items-center justify-center w-full h-full bg-white rounded-xl border border-gray-200">
        <div className="flex flex-col items-center gap-4 px-8 text-center">
          <img src={WhatappPNG} alt="whatsapp" className="w-16 h-16 opacity-80" />
          <div className="font-SFPro font-semibold text-xl text-gray-900">
            Start a conversation
          </div>
          <div className="font-inter text-sm text-gray-500 max-w-xs leading-relaxed">
            Select a contact from the list to view or continue a conversation
          </div>
        </div>
      </div>
    );
  }
}

export default WhatsAppNewChat;
